import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/fit';
import * as Translations from '../../providers/i18n';

const DeletePopup = ({ handleNoOnDeletePopup, handleYesOnDeletePopup, i18n }) => (
    <div className="delete-popup-wrapper">
        <div className="to-delete font-accent">
            <div className="text">
                <h3>{i18n.t('attachments_preview.delete_popup.title')}</h3>
            </div>
            <div className="buttons-container">
                <Button fill="ghost" color="grey" className="no-button" onClick={handleNoOnDeletePopup}>{i18n.t('attachments_preview.delete_popup.cancel_button')}</Button>
                <Button onClick={handleYesOnDeletePopup}>{i18n.t('attachments_preview.delete_popup.delete_button')}</Button>
            </div>
        </div>
    </div>
);

DeletePopup.propTypes = {
    handleYesOnDeletePopup: PropTypes.func,
    handleNoOnDeletePopup: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

DeletePopup.defaultProps = {
    handleYesOnDeletePopup: () => null,
    handleNoOnDeletePopup: () => null
};

export default Translations.connect(DeletePopup);
